<!--
 * @Author: your name
 * @Date: 2020-11-24 12:17:18
 * @LastEditTime: 2020-11-24 14:56:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \solax-design\src\views\adminInverter\adminInverter.vue
-->
<template>
    <div class="adminInverter-main-box">
        <div class="search-box">
            <div class="search-box-sub">
                <span class="lable-text">{{$t('project.data.region')}}</span>
                <el-select v-model="regionID" filterable :placeholder="$t('common.msg.select.please')" clearable>
                    <el-option
                            v-for="item in regions"
                            :key="item.regionID"
                            :label="item.regionNameInternational"
                            :value="item.regionID">
                    </el-option>
                </el-select>
            </div>
            <div class="search-box-sub">
                <span class="lable-text">{{$t('common.msg.country')}}</span>
                <el-input v-model="countryNameInternational" style="width:160px;" :placeholder="$t('common.info.pl-insert-content')"></el-input>
            </div>
            <div class="search-box-sub">
                <el-button type="primary" @click='query'>{{$t('common.button.query')}}</el-button>
            </div>
        </div>
        <div class="button-box">
            <el-button type="primary" class="marginR10" icon='el-icon-plus' @click="()=>{$router.push({path:'/addCountry'})}">{{$t('system.country.add')}}</el-button>
            <el-popconfirm
                    :title="$t('common.button.del-bath-confirm')"
                    @confirm='systemCountryDeleteBath()'
            >
                <el-button slot="reference" icon='el-icon-delete' class="marginR10" >{{$t('link.delete')}}</el-button>
            </el-popconfirm>
        </div>
        <baseTable v-loading="loading"  row-key='sid' :data="dataRows" border  stripe   :column='column' :select='true' @selection-change="handleSelectionChange($event)" >
            <template #countryNameInternational='{data}'>
                <a href="javascript:;" style="color: #4c98d9;" @click='pushEditUrl(data.countryID)'>{{data.countryNameInternational}}</a>
            </template>
            <template #option="{data}">
                <div class="option-box">
                    <el-popconfirm
                            :title="$t('common.button.del-bath-confirm')" @confirm='systemCountryDelete(data.countryID)'>
                        <i class="el-icon-delete" slot="reference"></i>
                    </el-popconfirm>
                </div>
            </template>
        </baseTable>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
</template>

<script>
import baseTable from '../../components/common/baseTable'
export default {
    components: {
        baseTable
    },
    props: {

    },
    data() {
        return {
            countryIDs:[],
            regionID:'',
            countryNameInternational:'',
            regions:[],
            manufacturerId:'',
            name:'',
            selectDataList:[],
            loading:false,
            dataRows:[],
            column:[{
                title: this.$t('project.data.region'),
                value: 'regionNameInternational',
            },{
                title: this.$t('common.msg.country'),
                value: 'countryNameInternational',
                slot: 'countryNameInternational'
            },{
                title: this.$t('common.msg.opeation'),
                value: 'option',
                slot: 'option'
            }],
            size:10,
            current:1,
            total:1
        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },

    mounted() {
        this.systemTCountryGetPage()
        this.getAllRegion()
    },

    methods: {
        /*批量删除*/
        async systemCountryDeleteBath(){
            let res = await this.API.systemTCountryDeleteBath({
                countryIDs:this.countryIDs
            })
            if(res.success){
                this.$message({
                    message: this.$t('operate.result.success'),
                    type: 'success'
                });
                this.systemTCountryGetPage()
            }else{
                this.$message({
                    message: this.$t('operate.result.fail'),
                    type: 'warning'
                });
            }
        },

        /*删除*/
        async systemCountryDelete(id){
            this.countryIDs = []
            this.countryIDs.push(id)
            this.systemCountryDeleteBath()
        },

        /*跳转编辑页面*/
        pushEditUrl(id){
            this.$router.push({path: '/addCountry', query: {id:id}});
        },


        /*列表查询*/
        async systemTCountryGetPage(){
            this.loading = true
            let res = await this.API.systemTCountryGetPage({
                regionID: this.regionID,
                countryNameInternational: this.countryNameInternational,
                current:this.current,
                size:this.size,
            })
            this.dataRows = res.rows
            this.total= parseInt(res.total)
            this.loading = false
        },


        /*获取所有区域*/
        async getAllRegion(){
            let res = await this.API.systemRegionsGetAll({})
            this.regions = res;
        },


        /*查询*/
        query(){
            this.current = 1
            this.systemTCountryGetPage()
        },


        handleSelectionChange(val){
            this.countryIDs=val.map( item=>{
                return item.countryID
            })
        },
        handleSizeChange(val) {
            this.size = val
            this.current = 1
            this.systemTCountryGetPage()
        },
        handleCurrentChange(val) {
            this.current = val
            this.systemTCountryGetPage()
        },
    },
};
</script>

<style  lang="less" scoped>

</style>
